<template>
    <BreadCrumb :items="breadcrumbItems" />
    <main id="main">
        <ApiGuideCampaignForm/>
    </main>
</template>
<script>
import ApiGuideCampaignForm from '@/components/apiGuide/ApiGuideCampaignForm.vue';
import BreadCrumb from '../layout/navigation/BreadCrumb.vue';

export default {
    data() {
        return {
            breadcrumbItems: [
                { href: "/", text: "홈", isHome: true },
                { href: "#", text: "API 연계가이드" },
            ],
        };
    },
    components: {
        ApiGuideCampaignForm,
        BreadCrumb
    }
}
</script>
<style lang="">
    
</style>